// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C9FU","toggleWrap":"styles_toggleWrap__2BmjG","content":"styles_content__1eIof","selectAreaCode":"styles_selectAreaCode__1zKDf"};